import { Box, Checkbox, Input, Spacer, Stack, useToast, VStack } from '@chakra-ui/react';
import { SubmitStepButton } from './SubmitStepButton';
import EmailEditor, { EditorRef, EmailEditorProps } from 'react-email-editor';

import { Labeled } from '@partiu/ui/components/molecules/Labeled.tsx';
import { useRef, useState } from 'react';

import { useForm } from 'react-hook-form';
import { useNotificationCentralContext } from '../notification-central.context';
import { IStep } from './interfaces';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider';
import { templateBuilder } from './template';

export function EditMessageStep({ onSubmit, HeaderComponent }: IStep) {
  const { formData } = useNotificationCentralContext();
  const emailEditorRef = useRef<EditorRef>(null);
  const { colors, logo } = useTheme();
  const toast = useToast();

  const onReady: EmailEditorProps['onReady'] = (unlayer) => {
    const initialTemplate = templateBuilder(logo, colors, formData.emailTitle, formData.emailBody);

    unlayer.loadDesign(initialTemplate);
  };

  const { register, watch } = useForm({
    defaultValues: {
      ...formData,
      emailBody: formData?.emailBody,
      emailTitle: formData?.emailTitle,
    },
  });

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const emailTitle = watch('emailTitle');
  const emailBody = watch('emailBody');
  const emailSubject = watch('emailSubject');

  const { setFormData } = useNotificationCentralContext();

  /*   const emailBodyForm = register('emailBody', { required: true });

  const handleImageUpload = async (blobInfo: any) => {
    const response = await uploadEmailImage(blobInfo);
    return response.data.file;
  }; */

  const handleSubmitStep = () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.exportHtml((data) => {
      const { html } = data;
      console.log('html', html);
      if (!html) {
        toast({
          title: 'Oops',
          description: 'Corpo do email ainda nao foi carregado ou incluído',
          status: 'error',
        });
        return;
      }
      setFormData((oldState) => ({
        ...oldState,
        html: html,
        emailBody,
        emailSubject,
        emailTitle,
      }));
      onSubmit();
    });
  };

  return (
    <>
      <HeaderComponent title={'Edite o template antes de enviar'} />
      <Stack direction={['column']} width="100%" alignItems={'center'} justifyContent={'center'} spacing={5}>
        <Stack direction={['column']} spacing={1} w={'100%'}>
          <form style={{ height: '100%', marginTop: 25 }}>
            <VStack height={'100%'} spacing={5}>
              <Labeled label={'Assunto'}>
                <Input {...register('emailSubject', { required: true })} />
              </Labeled>
              <Labeled label={'Título'}>
                <Input {...register('emailTitle', { required: true })} />
              </Labeled>
            </VStack>
          </form>
        </Stack>
        <Spacer />
        <Box width={'100%'}>
          <EmailEditor
            options={{
              designMode: 'email',
              locale: 'pt-BR',
            }}
            ref={emailEditorRef}
            onReady={onReady}
          />
        </Box>

        <Checkbox isChecked={acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)}>
          Estou ciente de que o conteúdo do email é de minha responsabilidade
        </Checkbox>
        <div style={{ marginLeft: 'auto' }}>
          <SubmitStepButton onSubmit={handleSubmitStep} isDisabled={!acceptedTerms} />
        </div>
      </Stack>
    </>
  );
}
